<template>
  <b-modal hide-footer centered :id="'InsufficientPointsModal'" size="lg" title-tag="p">
    <button type="button" class="close" slot="modal-header-close" aria-label="Close">
      <span></span>
      <span></span>
    </button>
    <section class="entity-non-logged-modal">
      <div class="container-fluid p-0">
        <div class="bg-white rounded p-5">
          <div class="row flex-column align-items-center my-5">
            <i class="icon icon-points xl mb-5 color-primary"></i>
            <span class="text-18 text-center w-50">
              {{ translate('rdYouDoNotHaveEnoughPoints') }}
            </span>
          </div>
          <div class="row mb-4">
            <div class="col-auto mt-5 m-auto d-flex align-items-center">
              <button
                class="btn btn-md btn-primary text-uppercase show-cash-rates"
                @click="showCashRates()"
              >
                <span>{{ translate('rdShowRatesInCash') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </b-modal>
</template>

<script>
export default {
  name: 'InsufficientPointsModal',
  methods: {
    showCashRates() {
      this.$emit('accept')
      this.$root.$emit('bv::hide::modal', 'InsufficientPointsModal')
    }
  }
}
</script>

<style></style>
